module.exports = __webpack_public_path__ + "img/16-05_Collaborating With Others.a80884d6.svg";